import { Routes } from '@angular/router';
import { HomepageComponent } from './components/homepage/homepage.component';
import { BookingComponent } from './components/booking/booking.component';
import { AboutComponent } from './components/about/about.component';
import { FaqComponent } from './components/faq/faq.component';
import { HoneymoonerComponent } from './components/booking/honeymooner/honeymooner.component';
import { AdventurerComponent } from './components/booking/adventurer/adventurer.component';
import { BusinessComponent } from './components/booking/business/business.component';
import { PlacesComponent } from './components/about/places/places.component';
import { ThingsComponent } from './components/about/things/things.component';
import { TravelComponent } from './components/plan/travel/travel.component';
import { AccomodationsComponent } from './components/plan/accomodations/accomodations.component';
import { TransportationComponent } from './components/plan/transportation/transportation.component';
import { FoodComponent } from './components/about/food/food.component';
import { ActivitiesComponent } from './components/about/activities/activities.component';
import { ToursComponent } from './components/about/tours/tours.component';

export const routes: Routes = [
  {path: '', component: HomepageComponent},
  {path: 'about', component: AboutComponent},
  {path: 'about/places', component: PlacesComponent},
  {path: 'about/places/:type', component: PlacesComponent},
  {path: 'about/things', component: ThingsComponent},
  {path: 'about/things/:type', component: ThingsComponent},
  {path: 'about/food', component: FoodComponent},
  {path: 'about/food/:type', component: FoodComponent},
  {path: 'about/activities', component: ActivitiesComponent},
  {path: 'about/activities/:type', component: ActivitiesComponent},
  {path: 'about/tours', component: ToursComponent},
  {path: 'about/tours/:type', component: ToursComponent},
  {path: 'plan/travel', component: TravelComponent},
  {path: 'plan/travel/:type', component: TravelComponent},
  {path: 'plan/accommodations', component: AccomodationsComponent},
  {path: 'plan/accommodations/:type', component: AccomodationsComponent},
  {path: 'plan/transportation', component: TransportationComponent},
  {path: 'plan/transporation/:type', component: TransportationComponent},
  {path: 'book', component: BookingComponent},
  {path: 'about/faq', component: FaqComponent},
  {path: 'book/honeymooner', component: HoneymoonerComponent},
  {path: 'book/adventurer', component: AdventurerComponent},
  {path: 'book/business', component: BusinessComponent}
];
